import { isAllowed } from '@security/User';

export const AllowedBlock = ({ roles, oneOfThem, children, ...props }) => {
  if (isAllowed(roles, oneOfThem)) return children;
  return null;
};
